import React from 'react';
import { FieldArray } from 'formik';
import { I18n } from '@td/shared_utils';
import { FieldLabel } from "@td/ui";
import { fieldTypes } from '../constants';
import ChecklistFieldArray  from './ChecklistFieldArray';


const ChecklistField = () => (
    <React.Fragment>
      <FieldLabel>
        <I18n scope="care_team_tasks.form.fields.checklist" text="label" />
      </FieldLabel>
      <FieldArray
        name={fieldTypes.CHECKLIST}
        component={ChecklistFieldArray}
      />
    </React.Fragment>
  );

export default ChecklistField;
